import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const verifyStoreApi = (data) =>
    Promise.resolve(axios.post(endpoints.verifyStore, data));
